import React from 'react'
import { Label } from 'react-bootstrap'
import * as App from 'modules/app/App';

class AssigneeStatus extends React.Component {
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	render() {
		if (this.props.value && this.props.value.assignee) {
			var assignee = this.props.value.assignee;
            var status = this.props.value.status.toUpperCase();
            var notRequired = this.props.value.notRequired;
			let bg = 'default';
			let type = 'default';

			const greenStatus = ["COM"];
			const yellowStatus = ["PGR", "SUB", "ASG", "VIP", "QUA", "HLD", "INC", "RAS"];
			const redStatus = ["NOQ", "DEN", "PDE"];

			var url = '#';

			if (this.props.dependentValues) {
				if (this.props.dependentValues.queueTypeCode === 'APP' && App.hasPrivilege("AdminAppReviewAccess"))
					url = `/admin/certification/${this.props.dependentValues.certificationKey}/appReview/${this.props.dependentValues.queueTypeCode}`;
				else if (this.props.dependentValues.queueTypeCode === 'CER' && App.hasPrivilege("AdminCertReviewAccess"))
					url = `/admin/certification/${this.props.dependentValues.certificationKey}/certReview/${this.props.dependentValues.queueTypeCode}`;
				else if (this.props.dependentValues.queueTypeCode === 'STR' && App.hasPrivilege("AdminSiteReviewAccess"))
					url = `/admin/siteReview/${this.props.dependentValues.certificationKey}/siteInfo/${this.props.dependentValues.queueTypeCode}`;
				else if (this.props.dependentValues.queueTypeCode === 'COM' && App.hasPrivilege("AdminCommReviewAccess"))
					url = `/admin/certification/${this.props.dependentValues.certificationKey}/comReview/${this.props.dependentValues.queueTypeCode}`;
				else if (this.props.dependentValues.queueTypeCode === 'FIN' && App.hasPrivilege("AdminFinalReviewAccess"))
					url = `/admin/certification/${this.props.dependentValues.certificationKey}/finalReview/${this.props.dependentValues.queueTypeCode}`;
			}

            if (notRequired) {
                bg = '#E7E6E6';
				type = '#000000';
            }
			else if (greenStatus.includes(status)) {
				bg = '#43d162';
				type = '#000000';
			}
			else if (yellowStatus.includes(status)) {
				bg = '#dec02c';
				type = '#000000';
			}
			else if (redStatus.includes(status)) {
				bg = '#ba1111';
				type = '#FFFFFF';
			}

			let labelContent = assignee;

			if (this.props.dependentValues && this.props.dependentValues.queueTypeCode === 'COM') {
				if (yellowStatus.includes(status)) {
					labelContent = assignee;
				}
				else if (greenStatus.includes(status)) {
					if (this.props.value.commVotesIsAnyDenied) {
						bg = '#ba1111';
						type = '#FFFFFF';
					}
				}
				else if (redStatus.includes(status)){
					bg = '#ba1111';
					type = '#FFFFFF';
					labelContent = "Completed";
				}
				else
					labelContent = "";
			}

			let style = {
				backgroundColor: bg,
				color: type,
				display: "block",
				position: "relative",
				width: "100%",
				height: "34px",
				paddingTop: "10px",
				margin: "0",
				padding: "0"
			};

			return (
				<a href={url}>
					<Label style={style}>
						<span style={{ display: "block", paddingTop: "12px" }}>{labelContent}</span>
					</Label>
				</a>);
		}
		else
			return <Label></Label>;
	}
}


export default AssigneeStatus;



// WEBPACK FOOTER //
// ./src/areas/admin/shared/AssigneeStatus.js